<script setup lang="ts">
// import * as Sentry from '@sentry/vue';

definePageMeta({
  layout: 'default',
});

const { $posthog } = useNuxtApp();

const props = defineProps({
  error: Object,
});

const handleError = () => clearError({ redirect: '/' });

onMounted(() => {
  // Sentry.captureException(props.error);
  if ($posthog) {
    const posthog = $posthog();

    // Convert Nuxt error object to proper Error instance for PostHog
    const error = new Error(props.error?.message || 'Unknown error');
    error.name = 'NuxtError';
    error.stack = props.error?.stack || error.stack;

    // Add additional context as extra data
    posthog?.captureException(error, {
      statusCode: props.error?.statusCode,
      statusMessage: props.error?.statusMessage,
      code: props.error?.code,
      url: props.error?.url,
    });
  }
});
</script>

<template>
  <NuxtLayout>
    <div
      class="bg-neutral-950 text-white py-10 xl:py-20 flex items-center justify-center flex-col gap-5"
    >
      <div class="max-w-[800px] mx-auto px-4 lg:px-8">
        <img
          class="z-[1] object-fill w-full max-w-[300px] mb-20"
          src="~/assets/images/logo-dark.svg"
          alt=""
        />
        <UCard class="!bg-cardinal">
          <h2 class="text-3xl mb-5 font-extrabold">Looks like we've encountered an error</h2>
          <p class="mb-5">
            We're sorry for the inconvenience. Our engineers have been notified of this error.
          </p>
          <button
            class="inline-flex items-center justify-center border px-3 py-2 border-white mt-5"
            @click="handleError"
          >
            Back to Home
          </button>
        </UCard>
        <!-- <pre class="text-sm">{{ error }}</pre> -->
        <UCard class="!bg-black mt-[50vh] text-xs">
          <h2 class="text-lg font-extrabold">Debugging Details:</h2>
          <h2 class="font-mono">code: {{ error.code }}</h2>
          <h2 class="font-mono">statusMessage: {{ error.statusMessage }}</h2>
          <h2 class="font-mono">message: {{ error.message }}</h2>
          <div class="mt-5 text-cardinal-200 font-mono" v-html="error.stack"></div>
        </UCard>
      </div>
    </div>
  </NuxtLayout>
</template>
